import React from "react";
import { Box, Typography } from "@mui/material";
import I18n from "i18next";
import MzSwitch from "@markaaz/ui/MzSwitch";

const sx = {
  contentBox: {
    marginTop: "40px",
    display: "flex",
    gap: "50px"
  },
  placeHolderText: {
    color: (theme) => theme.palette.blue.c100,
    textTransform: "uppercase"
  },
  boxBorder: {
    minWidth: "150px",
    borderLeft: "1px solid #0a78cd",
    padding: "10px 0px 10px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "11px"
  },
  value: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  }
};

export default function MonitoringReportFrequency(props) {
  const {
    placeHolderText1,
    placeHolderText2,
    startDate,
    endDate,
    onMonitoringChange,
    monitoringKey,
    monitoringChecked,
    reportFrequency = "Monthly"
  } = props;
  return (
    <Box sx={sx.contentBox}>
      <Box sx={sx.boxBorder}>
        <Typography variant="overline1" sx={sx.placeHolderText}>
          {placeHolderText1}
        </Typography>
        <Box>
          {startDate ? (
            <Typography variant="body2" color="darkBlue.c100">
              {startDate}
            </Typography>
          ) : (
            <Box sx={sx.value}>
              <MzSwitch
                checked={monitoringChecked}
                onChange={() => {
                  onMonitoringChange({
                    key: monitoringKey,
                    value: !monitoringChecked
                  });
                }}
              />
              <span className="enabled-disabled">
                {monitoringChecked ? I18n.t("common.enabled") : I18n.t("common.disabled")}
              </span>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={sx.boxBorder}>
        <Typography variant="overline1" sx={sx.placeHolderText}>
          {placeHolderText2}
        </Typography>
        {endDate ? (
          <Typography variant="body2" color="darkBlue.c100">
            {endDate}
          </Typography>
        ) : (
          <Box sx={sx.value}>{reportFrequency || I18n.t("monitoringConfiguration.monthly")}</Box>
        )}
      </Box>
    </Box>
  );
}
